import type { UserProps } from '../model/User';
import type { ListingReducerProps } from '../reducers/listing/listing';

const enterpriseUtils = {
  getMustSetCustomerId: (
    listing: ListingReducerProps,
    user: UserProps,
    paidMultifamilyLocation = false,
    hasAnyExpiredContracts = false,
    hasActiveContracts = false,
  ) => {
    const { customerId, isRoomForRent, isMultifamily } = listing;
    const { isSingleFamilyEnterpriseCustomer, isMultifamilyCustomer, userManagementCompanyId } = user;

    if (!isSingleFamilyEnterpriseCustomer) {
      return false;
    }
    if (!userManagementCompanyId) {
      return false;
    }
    if (!hasActiveContracts && hasAnyExpiredContracts) {
      return false;
    }
    if (isRoomForRent && !isMultifamily) {
      return false;
    }
    if (isMultifamily && paidMultifamilyLocation && isMultifamilyCustomer) {
      return false;
    }
    return !customerId;
  },
};

export default enterpriseUtils;
